export default "__VITE_ASSET__DK1Ryqpl__"